// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"af8306ac","455":"ec888eb8","977":"1b400af5"}[chunkId] + ".chunk.js";
};